<template>
  <div id="estimate-history" class="content">
    <div>
      <h2 class="page-title">お見積り履歴</h2>
      <!-- 検索項目 -->
      <h4 class="page-sub-title pl-2 pl-md-4">検索</h4>
      <section id="history-search">
        <div class="section-child p-2">
          <div class="row pb-1 mx-0">
            <div class="col-md-4">
              <div class="row">
                <label class="col-md-form-label col-md-5 pt-2 px-0 px-md-3 m-0">
                  お見積り番号
                </label>
                <input
                  type="text"
                  class="form-control col-md-6"
                  v-model="searchCond.MITUMORI_BANGO"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <label class="col-md-form-label col-md-4 pt-2 px-0 px-md-3 m-0">
                  車名
                </label>
                <input
                  type="text"
                  class="form-control col-md-7"
                  v-model="searchCond.SYARYO_MEI"
                />
              </div>
            </div>
          </div>

          <Accordion title="詳細検索" class="accordion" ref="search_accordion">
            <div class="row pb-2 mx-0">
              <div class="col-md-4">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-5 pt-2 px-0 px-md-3 m-0"
                  >
                    引取先
                  </label>
                  <input
                    type="text"
                    class="form-control col-md-6"
                    v-model="searchCond.HIKITORI_MEI"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-4 pt-2 px-0 px-md-3 m-0"
                  >
                    納車先
                  </label>
                  <input
                    type="text"
                    class="form-control col-md-7"
                    v-model="searchCond.NOSYA_MEI"
                  />
                </div>
              </div>
            </div>
            <div class="row pb-2 mx-0">
              <div class="col-lg-6">
                <div class="row">
                  <label
                    class="col-md-form-label col-md-3 pt-2 px-0 px-md-3 m-0"
                  >
                    お見積り料金
                  </label>
                  <input
                    type="number"
                    class="form-control ml-md-3 col-md-4"
                    v-model="searchCond.RYOKIN_FROM"
                  />
                  <span class="ml-3 ml-md-0 p-md-2">〜</span>
                  <input
                    type="number"
                    class="form-control col-md-4"
                    v-model="searchCond.RYOKIN_TO"
                  />
                </div>
              </div>
              <div class="col-lg-6 mt-3 mt-lg-0">
                <div class="row">
                  <label
                    :class="[
                      'col-md-form-label col-md-2 col-lg-3 pt-2 px-0 px-md-3 m-0',
                      { 'text-right': isPC },
                    ]"
                  >
                    お見積り日
                  </label>
                  <DatePicker
                    clearable
                    format="YYYY-MM-DD"
                    class="ml-md-3 col-md-4 p-0"
                    v-model="torokuNichijiFrom"
                  />
                  <span class="ml-3 ml-md-0 p-md-2">〜</span>
                  <DatePicker
                    clearable
                    format="YYYY-MM-DD"
                    class="col-md-4 p-0"
                    v-model="torokuNichijiTo"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-9 px-3 pt-2">
              <div class="row">
                <label
                  class="
                    col-md-form-label col-md-3 col-lg-2
                    pt-2
                    px-0 px-md-3
                    m-0
                  "
                >
                  ステータス
                </label>
                <div class="mt-md-2 ml-lg-3">
                  <div
                    class="form-check form-check-inline"
                    v-for="(item, i) in statusList"
                    :key="i"
                  >
                    <md-checkbox
                      class="form-check-input md-primary"
                      v-model="searchCond.STATUS"
                      :value="item.value"
                    >
                      {{ item.text }}
                    </md-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </Accordion>
          <div class="text-right mt-3 mt-md-0">
            <b-button
              class="btn btn-success mr-2 p-0 search-btn"
              @click="search"
            >
              検索
            </b-button>
            <b-button
              class="btn btn-secondary mr-2 p-0 search-btn"
              @click="resetCond"
            >
              リセット
            </b-button>
          </div>
        </div>
      </section>

      <!-- 検索一覧 -->
      <div>
        <h4 class="page-sub-title pl-2 pl-md-4 mt-4">お見積り履歴一覧</h4>

        <div v-if="isMobile" class="col-md-4 mt-2 mt-md-0">
          <label class="d-inline col-5">並び替え：</label>
          <select
            class="form-control form-input d-inline col-7 mb-2 mb-md-0"
            v-model="sortItem"
            @change="mobileSort"
          >
            <option v-for="item in sortList" :value="item" :key="item.text">
              {{ item.text }}
            </option>
          </select>
        </div>

        <md-table
          v-model="mitumoriByPage"
          :class="['estimate-table mx-0', { mobile: isMobile }]"
          :md-sort.sync="searchCond.SORT_BY"
          :md-sort-order.sync="searchCond.SORT_DESC"
          :md-sort-fn="sort"
          md-card
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <template v-if="isMobile">
              <mobile-cell :label="getText(headers, 'TOROKU_NICHIJI')">
                <template #cell>
                  <span v-if="item.TOROKU_NICHIJI">
                    {{ item.TOROKU_NICHIJI.slice(0, 10) }}
                  </span>
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(headers, 'MITUMORI_BANGO')">
                <template #cell>
                  {{ item.MITUMORI_BANGO }}
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(headers, 'STATUS')">
                <template #cell>
                  <md-chip
                    v-if="getParam(statusList, item.STATUS)"
                    :class="getParam(statusList, item.STATUS).color"
                  >
                    {{ getText(statusList, item.STATUS) }}
                  </md-chip>
                  <span v-else>
                    {{ getText(statusList, item.STATUS) }}
                  </span>
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(headers, 'HIKITORI_MEI')">
                <template #cell>
                  {{ item.HIKITORI_TODO_MEI }}{{ item.HIKITORI_SHIKU_MEI }}
                  <br />
                  {{ item.HIKITORI_MEI }}
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(headers, 'NOSYA_MEI')">
                <template #cell>
                  {{ item.NOSYA_TODO_MEI }}{{ item.NOSYA_SHIKU_MEI }}
                  <br />
                  {{ item.NOSYA_MEI }}
                </template>
              </mobile-cell>
              <mobile-cell :label="getText(headers, 'RYOKIN')">
                <template #cell>
                  <span v-if="item.RYOKIN">
                    ￥{{ item.RYOKIN.toLocaleString() }}
                  </span>
                  <span v-else class="text-danger">別途お見積り</span>
                </template>
              </mobile-cell>
              <mobile-cell :is-right="true">
                <template #cell>
                  <md-badge
                    v-if="isMidokuNum(item)"
                    class="bg-danger text-white"
                    :md-content="isMidokuNum(item)"
                    md-dense
                  >
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      @click="gotoDetail(item)"
                    >
                      <strong>詳細</strong>
                    </button>
                  </md-badge>
                  <button
                    v-else
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="gotoDetail(item)"
                  >
                    <strong>詳細</strong>
                  </button>
                  <button
                    v-if="isOrder(item)"
                    type="button"
                    class="btn btn-success btn-sm"
                    @click="orderConfirm(item)"
                  >
                    <strong>発注</strong>
                  </button>
                </template>
              </mobile-cell>
            </template>

            <template v-else>
              <md-table-cell
                :md-label="getText(headers, 'TOROKU_NICHIJI')"
                md-sort-by="TOROKU_NICHIJI"
              >
                <span v-if="item.TOROKU_NICHIJI">
                  {{ item.TOROKU_NICHIJI.slice(0, 10) }}
                </span>
              </md-table-cell>
              <md-table-cell
                :md-label="getText(headers, 'MITUMORI_BANGO')"
                md-sort-by="MITUMORI_BANGO"
              >
                {{ item.MITUMORI_BANGO }}
              </md-table-cell>
              <md-table-cell
                :md-label="getText(headers, 'STATUS')"
                md-sort-by="STATUS"
              >
                <md-chip
                  v-if="getParam(statusList, item.STATUS)"
                  :class="getParam(statusList, item.STATUS).color"
                >
                  <strong>{{ getText(statusList, item.STATUS) }}</strong>
                </md-chip>
                <span v-else>{{ getText(statusList, item.STATUS) }}</span>
              </md-table-cell>
              <md-table-cell
                :md-label="getText(headers, 'SYARYO_MEI')"
                md-sort-by="SYARYO_MEI"
              >
                {{ item.SYARYO_MEI }}
              </md-table-cell>
              <md-table-cell
                :md-label="getText(headers, 'HIKITORI_MEI')"
                md-sort-by="HIKITORI_MEI"
              >
                {{ item.HIKITORI_TODO_MEI }}{{ item.HIKITORI_SHIKU_MEI }}
                <br />
                {{ item.HIKITORI_MEI }}
              </md-table-cell>
              <md-table-cell
                :md-label="getText(headers, 'NOSYA_MEI')"
                md-sort-by="NOSYA_MEI"
              >
                {{ item.NOSYA_TODO_MEI }}{{ item.NOSYA_SHIKU_MEI }}
                <br />
                {{ item.NOSYA_MEI }}
              </md-table-cell>
              <md-table-cell
                :md-label="getText(headers, 'RYOKIN')"
                md-sort-by="RYOKIN"
              >
                <span v-if="item.RYOKIN">
                  ￥{{ item.RYOKIN.toLocaleString() }}
                </span>
                <span v-else class="text-danger">別途お見積り</span>
              </md-table-cell>
              <md-table-cell>
                <md-badge
                  v-if="isMidokuNum(item)"
                  class="bg-danger text-white"
                  :md-content="isMidokuNum(item)"
                  md-dense
                >
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="gotoDetail(item)"
                  >
                    <strong>詳細</strong>
                  </button>
                </md-badge>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="gotoDetail(item)"
                >
                  <strong>詳細</strong>
                </button>
                <button
                  v-if="isOrder(item)"
                  type="button"
                  class="btn btn-success btn-sm"
                  @click="orderConfirm(item)"
                >
                  <strong>発注</strong>
                </button>
              </md-table-cell>
            </template>
          </md-table-row>
        </md-table>
        <p class="red f-size-12 mt-2">
          ※引取先・納車先が変動する場合は、料金・納期を変更させていただく可能性がございます。
        </p>

        <paginate
          v-model="page.CURRENT_PAGE"
          ref="paginate"
          class="mt-3"
          :page-count="pageCount"
          :page-range="3"
          :margin-pages="2"
          :click-handler="changePage"
          :prev-text="'＜'"
          :next-text="'＞'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
        />
      </div>
    </div>

    <OrderConfirmDialog
      v-model="isDialogOrder"
      :mitumori="editedItem"
      @order="order"
      @retry-estimate="retryEstimate"
      @opened="scroll('locked')"
      @closed="scroll('clear')"
    />

    <md-snackbar
      class="bg-danger"
      md-position="center"
      :md-active.sync="isSnackbarError"
      :md-duration="10"
      md-persistent
    >
      <span>{{ snackbarText }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import MobileCell from '@/components/base/MobileCell'
import MitumoriMixin from '@/components/mixin/MitumoriMixin'
import Mixin from '@/components/mixin/Mixin'
import Accordion from '@/components/utils/Accordion'
import Const from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'
import OrderConfirmDialog from './OrderConfirmDialog'

const _searchCond = {
  MITUMORI_BANGO: null,
  TOROKU_NICHIJI_FROM: null,
  TOROKU_NICHIJI_TO: null,
  STATUS: [],
  RYOKIN_FROM: null,
  RYOKIN_TO: null,
  HIKITORI_MEI: null,
  NOSYA_MEI: null,
  SYARYO_MEI: null,
  SHITAGAKI_FLG: 0,
  SORT_BY: 'TOROKU_NICHIJI',
  SORT_DESC: 'desc',
  PAGE: 1,
  PAGE_LIMIT: 10,
}

const fields = {
  mitumori: '*',
  mitumori_rireki: ['ID', 'KIDOKU_FLG', 'LOGICO_FLG', 'MAIL'],
}
export default {
  name: 'EstimateIndex',
  components: {
    Accordion,
    MobileCell,
    OrderConfirmDialog,
  },
  mixins: [Mixin, MitumoriMixin],
  data: () => ({
    _mitumoriByPage: [],
    /** 見積り一覧データ */
    mitumoriList: [],

    /** 総件数（バックエンドより返却） */
    total: 0,

    /** 検索条件 */
    searchCond: _.cloneDeep(_searchCond),

    /** 失敗スナックバー表示フラグ */
    isSnackbarError: false,

    /** スナックバー表示テキスト */
    snackbarText: null,

    /** 対象データ */
    editedItem: null,

    /** データ取得中フラグ */
    isLoading: false,

    /** 削除ダイアログ表示フラグ */
    isDialogDelete: false,

    /** 発注 */
    isDialogOrder: false,

    /** ページングデータ */
    page: {
      PER_PAGE: 10,
      CURRENT_PAGE: 1,
    },

    /** ソートデータ */
    sortItem: {
      sortBy: 'TOROKU_NICHIJI',
      sortOrder: 'desc',
      text: 'お見積り日▼',
    },

    /** 営業所一覧 */
    salesOfficeList: [
      { text: '西業務部１課', value: '西業務部１課' },
      { text: '東業務部１課', value: '東業務部１課' },
    ],

    /** テーブルヘッダ */
    headers: [
      { text: 'お見積り日', value: 'TOROKU_NICHIJI' },
      { text: 'お見積り番号', value: 'MITUMORI_BANGO' },
      { text: '車名', value: 'SYARYO_MEI' },
      { text: 'ステータス', value: 'STATUS' },
      { text: '引取先', value: 'HIKITORI_MEI' },
      { text: '納車先', value: 'NOSYA_MEI' },
      { text: 'お見積り料金', value: 'RYOKIN' },
      { text: '', value: 'actions' },
    ],

    /** ソートデータ */
    sortList: [
      { sortBy: 'TOROKU_NICHIJI', sortOrder: 'asc', text: 'お見積り日▲' },
      { sortBy: 'TOROKU_NICHIJI', sortOrder: 'desc', text: 'お見積り日▼' },
      { sortBy: 'MITUMORI_BANGO', sortOrder: 'asc', text: 'お見積り番号▲' },
      { sortBy: 'MITUMORI_BANGO', sortOrder: 'desc', text: 'お見積り番号▼' },
      { sortBy: 'STATUS', sortOrder: 'asc', text: 'ステータス▲' },
      { sortBy: 'STATUS', sortOrder: 'desc', text: 'ステータス▼' },
      { sortBy: 'SYARYO_MEI', sortOrder: 'asc', text: '車名▲' },
      { sortBy: 'SYARYO_MEI', sortOrder: 'desc', text: '車名▼' },
      { sortBy: 'HIKITORI_MEI', sortOrder: 'asc', text: '引取先▲' },
      { sortBy: 'HIKITORI_MEI', sortOrder: 'desc', text: '引取先▼' },
      { sortBy: 'NOSYA_MEI', sortOrder: 'asc', text: '納車先▲' },
      { sortBy: 'NOSYA_MEI', sortOrder: 'desc', text: '納車先▼' },
    ],
  }),

  created() {
    const params = this.$route.params
    if (params) {
      if (params.searchCond) this.searchCond = params.searchCond
      if (params.page) this.page = params.page
    }
    // 詳細画面から戻ってきた場合は、同条件で一覧を復元する
    if (params && (params.searchCond || params.page)) {
      this.search()
    }
  },

  methods: {
    /**
     * ページング時
     * @param  {Number} pageNum 表示ページ
     */
    changePage(pageNum) {
      this.page.CURRENT_PAGE = pageNum
      this.search()
    },

    /** 検索する */
    async search() {
      this.spinerOn()
      // ページ情報は画面の状態を優先
      this.searchCond.PAGE = this.page.CURRENT_PAGE
      this.searchCond.PAGE_LIMIT = this.page.PER_PAGE

      await Store.dispatch('mitumori/find', {
        cond: this.searchCond,
        fields: fields,
      })
        .then((res) => {
          this.mitumoriList = res.data
          this.total = res.total
        })
        .catch((err) => {
          this.snackbarText = 'エラーが発生しました code: 401'
          this.isSnackbarError = true
        })
      this.spinerOff()
    },

    /** ソートする */
    sort() {
      this.page.CURRENT_PAGE = 1
      this.search()
    },

    /** ソートする(モバイル用) */
    mobileSort() {
      this.searchCond.SORT_BY = this.sortItem.sortBy
      this.searchCond.SORT_DESC = this.sortItem.sortOrder
      this.sort()
    },

    /** 検索条件リセット */
    resetCond() {
      this.searchCond = _.cloneDeep(_searchCond)
      this.page.CURRENT_PAGE = 1
      this.mitumoriList = []
      this.total = 0
    },

    /**
     * 発注確認する
     * @param  {Object} item 見積
     */
    orderConfirm(item) {
      this.editedItem = item
      this.isDialogOrder = true
    },

    /** 発注する */
    order(item) {
      this.spinerOn()
      this.isDialogOrder = false
      this.mitumoriOrder(this.editedItem.ID)
    },

    /**
     * 詳細画面に遷移する
     * @param  {Object} item 見積データ
     */
    gotoDetail(item) {
      this.$router.push({
        name: 'EstimateDetail',
        params: { id: item.ID, searchCond: this.searchCond, page: this.page },
      })
    },

    /**
     * 未読メッセージが存在するか
     * @param item 見積
     */
    isMidokuNum(item) {
      let count = 0
      if (!item.mitumori_rireki) return 0
      for (const v of item.mitumori_rireki) {
        if (v.MAIL && v.LOGICO_FLG && !v.KIDOKU_FLG) count++
      }
      return count
    },

    /**
     * 発注可能か判定
     * @param  {Object}  item 見積
     * @return {Boolean}
     */
    isOrder(item) {
      return item.STATUS !== Const.status.jyucyu && item.RYOKIN
    },

    /**
     * 再見積りする
     */
    retryEstimate() {
      this.isDialogOrder = false
      this.$router.push({
        name: 'TrialIndex',
        params: { mitumoriData: this.editedItem },
      })
    },

    getSyubetu(item, hikino) {
      return this.getMitumoriSyubetu(item, hikino)
    },

    /** 引取種別を返却 */
    hSyubetu(item) {
      return this.getSyubetu(item, 'HIKITORI')
    },

    /** 納車種別を返却 */
    nSyubetu(item) {
      return this.getSyubetu(item, 'NOSYA')
    },
  },

  computed: {
    /** ページ総数を返却する */
    pageCount() {
      return Math.ceil(this.total / this.page.PER_PAGE)
    },

    /** 表示ページ内の見積データ */
    mitumoriByPage: {
      get() {
        // サーバサイドページングなので、そのまま表示する
        return this.mitumoriList || []
      },
      set() {},
    },

    /** 登録日時FROM */
    torokuNichijiFrom: {
      get() {
        return this.searchCond.TOROKU_NICHIJI_FROM
          ? new Date(this.searchCond.TOROKU_NICHIJI_FROM)
          : null
      },
      set(newVal) {
        this.searchCond.TOROKU_NICHIJI_FROM = this.dateObjToStr(newVal)
      },
    },

    /** 登録日時To */
    torokuNichijiTo: {
      get() {
        return this.searchCond.TOROKU_NICHIJI_TO
          ? new Date(this.searchCond.TOROKU_NICHIJI_TO)
          : null
      },
      set(newVal) {
        this.searchCond.TOROKU_NICHIJI_TO = this.dateObjToStr(newVal)
      },
    },
  },
}
</script>

<style lang="sass">
/** 見積ダイアログ */
.order.md-dialog
  .md-dialog-container
    width: 95%
    max-width: 700px
#estimate-history
</style>



// WEBPACK FOOTER //
// src/components/estimate/Index.vue